export const isEnter = e => {
  return e.key === 'Enter';
};

export const isEscape = e => {
  return e.key === 'Escape';
};

export const hasPressedShift = e => {
  return e.shiftKey;
};

export const hasPressedCommand = e => {
  return e.metaKey;
};

export const hasPressedEnterAndNotCmdOrShift = e => {
  return isEnter(e) && !hasPressedCommand(e) && !hasPressedShift(e);
};

export const hasPressedCommandAndEnter = e => {
  return hasPressedCommand(e) && isEnter(e);
};

export const hasPressedCommandAndForwardSlash = e => {
  return e.metaKey && e.keyCode === 191;
};

export const hasPressedAltAndCKey = e => e.altKey && e.keyCode === 67;
export const hasPressedAltAndVKey = e => e.altKey && e.keyCode === 86;
export const hasPressedAltAndRKey = e => e.altKey && e.keyCode === 82;
export const hasPressedAltAndSKey = e => e.altKey && e.keyCode === 83;
export const hasPressedAltAndBKey = e => e.altKey && e.keyCode === 66;
export const hasPressedAltAndNKey = e => e.altKey && e.keyCode === 78;
export const hasPressedAltAndAKey = e => e.altKey && e.keyCode === 65;
export const hasPressedAltAndPKey = e => e.altKey && e.keyCode === 80;
export const hasPressedAltAndLKey = e => e.altKey && e.keyCode === 76;
export const hasPressedAltAndEKey = e => e.altKey && e.keyCode === 69;
export const hasPressedCommandPlusAltAndEKey = e =>
  e.metaKey && e.altKey && e.keyCode === 69;
export const hasPressedAltAndOKey = e => e.altKey && e.keyCode === 79;
export const hasPressedAltAndJKey = e => e.altKey && e.keyCode === 74;
export const hasPressedAltAndKKey = e => e.altKey && e.keyCode === 75;
export const hasPressedAltAndMKey = e => e.altKey && e.keyCode === 77;

// If layout is QWERTZ then we add the Shift+keysToModify to fix an known issue
// https://github.com/chatwoot/chatwoot/issues/9492
export const keysToModifyInQWERTZ = new Set(['Alt+KeyP', 'Alt+KeyL']);

export const LAYOUT_QWERTY = 'QWERTY';
export const LAYOUT_QWERTZ = 'QWERTZ';
export const LAYOUT_AZERTY = 'AZERTY';

/**
 * Determines whether the active element is typeable.
 *
 * @param {KeyboardEvent} e - The keyboard event object.
 * @returns {boolean} `true` if the active element is typeable, `false` otherwise.
 *
 * @example
 * document.addEventListener('keydown', e => {
 *   if (isActiveElementTypeable(e)) {
 *     handleTypeableElement(e);
 *   }
 * });
 */
export const isActiveElementTypeable = e => {
  /** @type {HTMLElement | null} */
  // @ts-ignore
  // composedPath()[0] traverses shadow DOM boundaries to get the real target element
  const activeElement =
    e.composedPath?.()[0] || e.target || document.activeElement;

  return !!(
    activeElement?.tagName === 'INPUT' ||
    activeElement?.tagName === 'NINJA-KEYS' ||
    activeElement?.tagName === 'TEXTAREA' ||
    activeElement?.contentEditable === 'true' ||
    activeElement?.className?.includes('ProseMirror')
  );
};
